export interface StorageEntityInfo {
  id: number;
  order_ref: string | null;
  order_id?: number;
  reserved_order_ref?: string;
  reserved_order_id?: number;
  pallet_sscc: string;
  ceel_number: string | null;
  boxes: number | null;
  kilos: number | null;
  product_number: string | null;
  product_name: string | null;
  production_date: string | null;
  expiration_date: string | null;
 // TODO - company_id not used but may be used in the future or delete
  company_id: number,
  customer_name: string | null
  stack_group_id: string | null;
}

export interface Place {
  id: number;
  place_id: string; // Format: "A-1-2-3" (area-row-placeNumber-level)
  address: string;
  rack_address?: string;
  old_address?: string;
  blocked: boolean;
  occupied: boolean;
  is_preparation: boolean;
  is_for_splitted_pallets: boolean;
  lastUpdated: string;
  areaCode: string;
  areaName: string;
  row: number;
  level: number;
  placeNumber: number;
  baseX: number;
  baseY: number;
  storage_entity_ids: Array<number>;
  // clickGeometry and clickGeometry2D are filled using side effects in renderers.
  clickGeometry?: any; // For stacked view
  clickGeometry2D?: any; // For 2D projection
  placeSelectionBorderColor?: string;
  placeSelectionBorderWidth?: number;
  placeDimensions: PlaceDimensions;
  // TODO - company_id not used but may be used in the future  or delete
  company_id: number,
  customer_name: string,
  pallet_company_id: number,
  pallet_customer_name: string,
  pallet_product_number: string,
  pallet_product_name: string,
  pallet_is_t1: boolean,
  product_article_id: number,
  product_name: string,
  place_type: PlaceType;
  placeMaxWeight?: number;
  placeCapacity?: number;
  areaTemperature?: AreaTemperature;
  isT1: boolean;
  isCrossDock?: boolean;
  isExternal?: boolean;
  isVirtual?: boolean;
  label?: string;
  lock_datetime_from?: string;
  lock_datetime_to?: string;
  comment?: string;
}

export interface AreaBoundary {
  name: string;
  polygon: Array<{ x: number; y: number }>;
  color: string;
  borderColor: string;
  bounds: { minX: number; minY: number; maxX: number; maxY: number };
}

export interface RowBoundary {
  name: string;
  label: string;
  polygon: Array<{ x: number; y: number }>;
  color: string;
  borderColor: string;
  rowSelectionBorderColor?: string;
  rowSelectionBorderWidth?: number;
}

export interface PortBoundary {
  id: number;
  name: string;
  polygon: Array<{ x: number; y: number }>;
  borderColor: string;
  borderSize: number;
  blocked: boolean;
  hitBox?: Array<{ x: number; y: number }> | null;
  lock_datetime_from?: string;
  lock_datetime_to?: string;
  comment?: string;
}

export interface RackBoundary {
  rowName: string;
  rackNumber: number;
  startPlace: number;
  endPlace: number;
  size: number;
}

export interface ViewState {
  offsetX: number;
  offsetY: number;
  scale: number;
  rotation: number; // rotation angle in radians
}

export interface PlaceDimensions {
  width: number;
  height: number;
  spacing: number;
  levelHeight: number;
}

export enum PlaceType {
  EPL_BPL = 0,
  EPL = 1,
  BPL = 2,
}

export enum AreaTemperature {
  COOLER = 'COOLER',
  FREEZER = 'FREEZER',
}
